<template>
  <form name="contract" class="needs-validation" novalidate>
    <div id="alert" class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4" :class="alert.color"
      role="alert" v-if="alert.message" ref="alert">
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong><br />
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group" :class="{ 'has-danger': !data.customer_id }">
          <label>Cliente
            <span v-if="!data.id" class="m--font-danger">*</span></label>
          <div>
            <SelectCustomers ref="customer_id" :selected="data.customer_id" :first="'Selecione um cliente'"
              @change="data.customer_id = $event" @loading="onLoadingCustomers" :disabled="!!data.id" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <label>Motivo da alteração <span class="m--font-danger">*</span></label>
        <div class="input-group">
          <input type="text" ref="change_reason" class="form-control" maxlength="255" v-model="data.change_reason"
            placeholder="Motivo da alteração" />
        </div>
      </div>
      <div class="col-md-3">
        <label>Grupo</label>
        <div class="input-group">
          <SelectCustomerContractReasonGroup @change="data.change_reason_group_id = $event"
            :selected="data.change_reason_group_id" :first="'Selecione um grupo'" ref="change_reason_group_id">
          </SelectCustomerContractReasonGroup>
        </div>
      </div>
    </div>

    <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
      <h5><i class="fas fa-file-contract"></i> Informações do Contrato</h5>
    </div>

    <div class="row mb-4">
      <div class="col-md-3">
        <div class="form-group">
          <label for="contract_id"> ID Contrato </label>
          <div class="input-group">
            <input type="number" class="form-control m-input" v-model="data.id" readonly />
          </div>
        </div>
      </div>
      <div class="col-md-3" v-if="this.contractId != 'add'">
        <label>Status do Contrato</label>
        <div class="input-group">
          <SelectContractsStatus :selected="data.status" @change="onChangeStatus($event)"
            :first="'Selecione um status'"></SelectContractsStatus>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group" :class="{ 'has-danger': !data.product_id }">
          <label>Produto
            <span v-if="!data.id" class="m--font-danger">*</span></label>
          <div class="input-group">
            <SelectProducts ref="product_id" :selected="data.product_id" :first="'Selecione um produto'"
              @change="data.product_id = $event" :disabled="data.id" />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group" :class="{ 'has-danger': !data.plan_type_id }">
          <label>Plano <span v-if="!data.id" class="m--font-danger">*</span></label>
          <div class="input-group">
            <SelectPlanTypes ref="plan_type_id" :selected="data.plan_type_id" :first="'Selecione um plano'"
              @change="data.plan_type_id = $event" />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-3">
        <div class="form-group mb-0">
          <label>Tipo contrato:
            <i class="fas fa-info-circle info-icon" v-b-tooltip
              title="PME e TC são as novas cobraças utilizando a faixa modular mista. Legado é para os contratos antigos onde são utilizados todas as faixas de cobrança."></i></label>
        </div>
        <div class="form-check form-check-inline" v-if="data.product_id != 7">
          <input id="pme" class="form-check-input" type="radio" v-model="data.contract_type" value="0" />
          <label class="form-check-label" for="pme" @click="data.contract_type = 0">PME</label>
        </div>
        <div class="form-check form-check-inline" v-if="data.product_id != 7">
          <input id="tc" class="form-check-input" type="radio" v-model="data.contract_type" value="2" />
          <label class="form-check-label" for="tc" @click="data.contract_type = 2">TC</label>
        </div>
        <div class="form-check form-check-inline" v-if="allowsLegacyContract">
          <input id="legado" class="form-check-input" type="radio" v-model="data.contract_type" value="1" />
          <label class="form-check-label" for="legado" @click="data.contract_type = 1">Legado</label>
        </div>
      </div>
      <div class="col-md-3" v-if="data.product_id == 1">
        <label>
          Contabilizar Enterprise:
          <span></span> </label><br />
        <div class="form-check form-check-inline">
          <input id="yes" class="form-check-input" type="radio" v-model="data.count_enterprise" value="1" />
          <label class="form-check-label" for="yes" @click="data.count_enterprise = 1">Sim</label>
        </div>
        <div class="form-check form-check-inline">
          <input id="no" class="form-check-input" type="radio" v-model="data.count_enterprise" value="0" />
          <label class="form-check-label" for="no" @click="data.count_enterprise = 0">Não</label>
        </div>
      </div>
      <div class="col-md-3">
        <label>Índice de reajuste</label>
        <div class="input-group">
          <SelectContractReadjustmentIndex :selected="data.readjustment_index_id"
            @change="onChangeReadjustmentIndex($event)" :first="'Selecione um índice'">
          </SelectContractReadjustmentIndex>
        </div>
      </div>
      <div class="col-md-3">
        <label>
          Contratado por:
          <span></span>
        </label>
        <div class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">
          <label class="btn btn-secondary" @click="data.hired_by = 0" :class="{ active: data.hired_by == 0 }">
            <input type="radio" name="hiredBy" v-model="data.hired_by" v-show="data.hired_by == 0" value="0" />
            Contrato
          </label>
          <label class="btn btn-secondary" @click="data.hired_by = 1" :class="{ active: data.hired_by == 1 }">
            <input type="radio" name="hiredBy" v-model="data.hired_by" v-show="data.hired_by == 1" value="1" />
            Termo
          </label>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': !data.start }">
          <label for="start">Início do contrato <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input id="start" type="date" max="9999-12-31" ref="start" class="form-control m-input" v-model="data.start"
              required />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': data.finish && data.start > data.finish }">
          <label for="finish">Fim do contrato
            <i class="fas fa-info-circle info-icon" v-b-tooltip
              title="Encerramento do contrato. Nenhuma fatura será gerada quando a data de 'Fim do contrato' for menor que a data de faturamento."></i></label>
          <div class="input-group">
            <input id="finish" type="date" ref="finish" max="9999-12-31" class="form-control m-input"
              v-model="data.finish" />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': !data.actual_contract_date }">
          <label for="actual_contract_date">Data atual do contrato <span class="m--font-danger">*</span>
            <i class="fas fa-info-circle info-icon" v-b-tooltip
              title="Data utilizada como base para mês aniversário do reajuste de contrato."></i></label>
          <div class="input-group">
            <input id="actual_contract_date" type="date" max="9999-12-31" ref="actual_contract_date"
              class="form-control m-input" v-model="data.actual_contract_date" required />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-4">
        <div class="form-group">
          <label for="grace_date">Data de carência
            <i class="fas fa-info-circle info-icon" v-b-tooltip.html
              title="Data de quando iniciam as cobranças de um contrato.<br>Exemplo:<br><b>Contrato feito em  </b> 16/10/2020<br><b>Período de carência</b> 1 Mês<br> Data de carência será 16/11/2020"></i></label>
          <div class="input-group">
            <input id="grace_date" type="date" ref="grace_date" max="9999-12-31" class="form-control m-input"
              v-model="data.grace_date" />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': !data.due_day && !data.due_in_days }">
          <label for="due_day">Dia do vencimento <span class="m--font-danger">* </span><i
              class="fas fa-info-circle info-icon" v-b-tooltip.html
              title="Dia do vencimento que será aplicado todo mês que gerar a fatura. <br>Exemplo:<br><b>Vencimento</b> 25<br><b>Faturamento dia</b> 01/10/2020<br>Vencimento da fatura será 25/10/2020"></i></label>
          <div class="input-group">
            <input id="due_day" oninput="this.value=this.value.slice(0,this.maxLength)" type="number"
              class="form-control m-input" step="1" min="1" max="30" maxlength="2" ref="due_day" v-model="data.due_day"
              required />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': !data.due_day && !data.due_in_days }">
          <label for="due_date">Prazo de vencimento <span class="m--font-danger">* </span>
            <i class="fas fa-info-circle info-icon" v-b-tooltip
              title="Prazo de vencimento sobrescreverá a regra de 'Dia do vencimento'. O vencimento será definido para X dias a partir do dia de faturamento."></i></label>
          <div class="input-group">
            <select class="form-control" v-model="data.due_in_days" @change="changedueInDays()" placeholder="asdads">
              <option value="null">Selecione um prazo</option>
              <option v-for="contractDueOption in contractDueOptions" :key="contractDueOption"
                :value="contractDueOption">
                {{ contractDueOption }} dias
              </option>
            </select>
            <small class="modified_field" v-if="data.due_in_days">
              <strong>Exemplo:</strong>
              <br />
              Faturamento hoje: {{ billingDateExample }} Vencimento dia:
              {{ dueDateExample }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3" v-show="data.product_id == 1 && data.contract_type == 1">
      <div class="col-md-4">
        <div class="form-group mb-0">
          <label>Cobrar por:
            <i class="fas fa-info-circle info-icon" v-b-tooltip.html title="<b>Carteira</b> - Faz o cálculo do consumo de cada carteira separadamente, somando o valor total de cada uma para ter o valor da fatura.<br>
                    <b>CNPJ</b> - Soma o consumo de cada carteira e depois faz o cálculo do consumo total da fatura.
                    "></i></label>
        </div>
        <div class="form-check form-check-inline">
          <input id="company" class="form-check-input" type="radio" v-model="data.billing_method" value="1" />
          <label class="form-check-label" for="company">Carteira</label>
        </div>
        <div class="form-check form-check-inline">
          <input id="cnpj" class="form-check-input" type="radio" v-model="data.billing_method" value="2" />
          <label class="form-check-label" for="cnpj">CNPJ</label>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group mb-0">
          <label>
            Agrupar detalhes da fatura por canal:
            <i class="fas fa-info-circle info-icon" v-b-tooltip
              title="Só é compatível por enquanto com a cobrança + envio de ativos e contrato do tipo Legado"></i>
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="group_invoice_by_channel"
            class="form-check-input"
            type="checkbox"
            v-model="data.group_invoice_by_channel"
            :true-value="1"
            :false-value="0"
          />
          <label class="form-check-label" for="group_invoice_by_channel">Ativar</label>
        </div>
      </div>
    </div>

    <div class="row mt-3" v-if="data.product_id == 7">
      <div class="col-md-12">
        <label for="note">Informações Chatbot</label>
        <div class="input-group">
          <input id="noteChatbot" type="text" class="form-control" placeholder="" v-model="data.note_chatbot" />
        </div>
      </div>
    </div>

    <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert" v-if="contractId !== 'add' && (data.product_id == 1 || data.product_id == 8)">
      <h5><i class="fas fa-link"></i> Vincular Carteiras Mktzap (Filial) a este contrato para faturamento</h5>
    </div>

    <div class="row mb-4" v-if="contractId !== 'add' && (data.product_id == 1 || data.product_id == 8)">
      <div class="col-md-12">
        <label>Carteiras</label>
        <div>
          <SelectCompaniesMultiple 
            @selected="selectedCompanies" 
            :customer-cnpj="customerCnpj"
            :contract-id="contractId"
            :key="data.customer_id"
          />
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <div class="form-group mb-0">
          <label>Enviar CSV da fatura por e-mail:</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="send_invoice_csv"
            class="form-check-input"
            type="checkbox"
            v-model="data.send_invoice_csv"
            :true-value="1"
            :false-value="0"
          />
          <label class="form-check-label" for="send_invoice_csv">Ativar</label>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <label for="note">Observações</label>
        <div class="input-group">
          <input id="note" type="text" class="form-control" placeholder="" v-model="data.note" />
        </div>
      </div>
    </div>

    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.customer_id.$el.focus()" target="_self" class="m--font-danger"
            v-if="!data.customer_id">O campo <strong>Cliente</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.product_id.$el.focus()" target="_self" class="m--font-danger"
            v-if="!data.product_id">O campo <strong>Produto</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.plan_type_id.$el.focus()" target="_self" class="m--font-danger"
            v-if="!data.plan_type_id">O campo <strong>Plano</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.due_day.focus()" target="_self" class="m--font-danger" v-if="
            !data.due_day && (!data.due_in_days || data.due_in_days == 'null')
          ">O campo <strong>Dia ou Prazo de Vencimento </strong> precisam ser
            preenchidos *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.due_day.focus()" target="_self" class="m--font-danger"
            v-if="data.due_day > 31">O campo <strong>Dia de Vencimento</strong> não é valido *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.start.focus()" target="_self" class="m--font-danger" v-if="!data.start">O
            campo <strong>Início do contrato</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.finish.focus()" target="_self" class="m--font-danger"
            v-if="data.finish && data.start > data.finish"><strong>Início do contrato</strong> não pode ser maior que o
            <strong>Fim do contrato</strong></a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.actual_contract_date.focus()" target="_self" class="m--font-danger"
            v-if="!data.actual_contract_date">O campo <strong>Data atual do contrato</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.change_reason_group_id.$el.focus()" target="_self" class="m--font-danger"
            v-if="!data.change_reason_group_id">O campo <strong>Grupo da alteração</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.change_reason.focus()" target="_self" class="m--font-danger"
            v-if="!data.change_reason">O campo <strong>Motivo da alteração</strong> é obrigatório *</a>
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button @click.prevent="saveForm()" class="btn" :class="{ 'btn-metal': !formIsValid || isAnyLoading, 'btn-focus': formIsValid && !isAnyLoading }"
          :disabled="!formIsValid || isAnyLoading">
          <i class="fas fa-spinner fa-spin" v-if="isAnyLoading"></i>
          <i class="fas fa-save" v-else-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          <span v-if="loadingCustomers">Carregando Clientes...</span>
          <span v-else-if="loading">Salvando...</span>
          <span class="ml-2" v-else>Salvar</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import SelectCustomers from '@/components/forms/SelectCustomers';
import SelectProducts from '@/components/forms/SelectProducts';
import SelectPlanTypes from '@/components/forms/SelectPlanTypes';
import SelectCustomerContractReasonGroup from '@/components/forms/SelectCustomerContractReasonGroup';
import SelectContractReadjustmentIndex from '@/components/forms/SelectContractReadjustmentIndex';
import SelectCompaniesMultiple from '@/components/forms/SelectCompaniesMultiple';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import moment from 'moment';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import SelectContractsStatus from '../forms/SelectContractStatus';
import { products } from '@/constants';

export default {
  mixins: [returnMessageFormMixin],
  name: 'CustomerContractSaveForm',
  components: {
    SelectCustomers,
    SelectProducts,
    SelectContractsStatus,
    SelectPlanTypes,
    SelectContractReadjustmentIndex,
    SelectCustomerContractReasonGroup,
    SelectCompaniesMultiple,
  },
  props: {
    contract: {
      type: Object,
    },
    changeReason: String,
    changeReasonGroup: String,
  },
  data() {
    const contractDueOptions =
      process.env.VUE_APP_CONTRACT_DUE_DATES.split(',');
    return {
      contractDueOptions,
      dueDateExample: '',
      billingDateExample: moment().format('DD/MM/YYYY'),
      data: {},
      customerData: null,
      loading: false,
      loadingCustomers: false,
      alert: {
        color: '',
        icon: '',
        message: '',
      },
      enterpriseSessionChecked: false,
    };
  },
  methods: {
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const { data } = this;

      this.loading = true;
      data.due_in_days = data.due_in_days != 'null' ? data.due_in_days : null;

      const url = `${baseApiUrl}/v1/customer/contract/save`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.$store.state.showContractSave = res.data.item.id;
          this.$emit('savedContract', res.data.item);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.logMessageFormFailed(error.response);
        });
    },
    onChangeStatus(status) {
      this.data.status = status;
    },
    onChangeReasonGroup(group) {
      this.data.change_reason_group_id = group;
    },
    onChangeReadjustmentIndex(ReadjustmentIndex) {
      this.data.readjustment_index_id = ReadjustmentIndex;
    },
    changedueInDays() {
      this.dueDateExample = moment()
        .add(this.data.due_in_days, 'days')
        .format('DD/MM/YYYY');
    },
    checkEnterpriseSessionAlert() {
      if (this.data.finish && this.contractId !== 'add' && !this.enterpriseSessionChecked) {
        this.enterpriseSessionChecked = true;
        const url = `${baseApiUrl}/v1/customer/contract/service/data/${this.contractId}`;
        axios.get(url)
          .then((res) => {
            if (res.data.enterpriseSession &&
              res.data.enterpriseSession.details &&
              res.data.enterpriseSession.details.length > 0 &&
              res.data.enterpriseSession.details.some(detail => detail.id)) {
              this.alert = {
                color: 'alert-warning',
                icon: 'fas fa-exclamation-triangle',
                message: 'Atenção: Este contrato possui cobrança de Sessão Enterprise. Para gerar o faturamento aguarde 1 dia para o processamento dos dados da Meta.'
              };
            }
          })

      } else if (!this.data.finish) {
        this.alert.message = '';
        this.enterpriseSessionChecked = false;
      }
    },
    selectedCompanies(companiesIds) {
      this.data.contract_ref_ids = companiesIds;
    },
    onLoadingCustomers(isLoading) {
      this.loadingCustomers = isLoading;
    },
    async fetchCustomerData() {
      if (this.data.customer_id && this.data.customer_id > 0) {
        try {
          const response = await axios.get(`${baseApiUrl}/v1/customer/data/${this.data.customer_id}`);
          this.customerData = response.data;
        } catch (error) {
          console.error('Erro ao buscar dados do cliente:', error);
          this.customerData = null;
        }
      } else {
        this.customerData = null;
      }
    },
  },
  computed: {
    contractId() {
      return this.$store.state.showContractSave;
    },
    allowsLegacyContract() {
      return this.data.product_id != products.WHATSAPP_ENTERPRISE &&
        this.data.product_id != products.YAPT;
    },
    customerCnpj() {
      if (this.customerData && this.customerData.documents && this.customerData.documents.value) {
        return this.customerData.documents.value;
      }
      return null;
    },
    showLoadingMessage() {
      return !this.customerCnpj;
    },
    isAnyLoading() {
      return this.loading || this.loadingCustomers;
    },
    formIsValid() {
      if (
        this.data.customer_id &&
        this.data.product_id &&
        this.data.plan_type_id &&
        this.data.change_reason_group_id &&
        (this.data.due_day ||
          (this.data.due_in_days && this.data.due_in_days != 'null')) &&
        this.data.start &&
        this.data.actual_contract_date &&
        this.data.due_day < 32 &&
        this.data.change_reason &&
        (!this.data.finish || this.data.start < this.data.finish)
      ) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.contractId === 'add') {
      this.data = {
        customer_id: 0,
        product_id: 0,
        plan_type_id: 0,
        due_day: '',
        start: '',
        billing_method: 2,
        contract_type: 0,
        due_in_days: null,
        hired_by: 0,
        count_enterprise: 1,
        blockedStart: '',
        blockedEnd: '',
        change_reason_group_id: 0,
        contract_ref_ids: [],
        group_invoice_by_channel: 0,
        send_invoice_csv: 0,
      };
    }

    if (this.data.customer_id) {
      this.fetchCustomerData();
    }
  },
  watch: {
    contract(newContract) {
      this.data = newContract;
      this.changedueInDays();
    },
    changeReason() {
      this.data.change_reason = this.changeReason;
    },
    changeReasonGroup() {
      this.data.change_reason_group_id = this.changeReasonGroup;
    },
    'data.finish'() {
      this.checkEnterpriseSessionAlert();
    },
    'data.customer_id'() {
      this.fetchCustomerData();
    },
    'data.product_id'() {
      if (this.contractId === 'add' && !this.allowsLegacyContract && this.data.contract_type == 1) {
        this.data.contract_type = 0;
      }
    },
  },
};
</script>
